import { z } from "zod";

export const createAdminSchema = z.object({
    adminPermissions: z.string().nonempty(),
    identificationType: z.string().nonempty(),
    identificationCode: z.string().nonempty(),
    name: z.string(),
    phone: z.string(),
    email: z.email(),
    userId: z.number().optional(),
});

export type CreateAdminDTO = z.infer<typeof createAdminSchema>;
